import React, { useEffect, useState } from "react";
import Box from "@material-ui/core/Box";
import { Container, Loading } from "@prestosports/commons-ui";
import classNames from "classnames";
import GameHeader from "../components/GameHeader";
import commonStyles from "../../common/styles/Common.styles";
import { useEventContext } from "../../../state/events/context";
import gameStatsContainerStyles from "../styles/GameStatsContainer.styles";
import { useMatchesContext } from "../../../state/matches/context";
import MissingStatsContainer from "../../game-stats/containers/MissingStatsContainer";
import GameStats from "../components/GameStats";
import TennisPrint from "../components/TennisPrint";
import gameContainerStyles from "../styles/GameContainer.styles";
import { useStatsContext } from "../../../state/stats/context";
import TennisExport from "../components/TennisExport";
import { useGameContext } from "../../../state/game/context";

const GameStatsContainer = () => {
	const commonClasses = commonStyles();
	const classes = gameStatsContainerStyles();
	const containerClasses = gameContainerStyles();
	const { state: statsState, getBoxScore } = useStatsContext();
	const { boxscore } = statsState.boxScore() || {};

	const { state: gameState } = useGameContext();
	const game = gameState.game();

	const { state: eventState } = useEventContext();
	const { state, getMatches } = useMatchesContext();

	const singles = state.singles();
	const doubles = state.doubles();

	const currentEvent = eventState.currentEvent();
	const { sportId, eventId, startDateTime } = currentEvent || {};

	const singlesAvailable = singles.length > 0;
	const doublesAvailable = doubles.length > 0;

	useEffect(() => {
		if (currentEvent) {
			getMatches(currentEvent.id);
		}
	}, [currentEvent]);

	useEffect(() => {
		if (game) {
			getBoxScore();
		}
	}, [game]);

	const [showPreview, setShowPreview] = useState();
	const fileName = `${eventId}-${startDateTime?.split("T")?.[0]}-${sportId}`;

	return (
		<>
			<GameHeader
				title="Game Reports"
				description="See statistics for the current game."
			/>
			<Box className={commonClasses.infoContainer}>
				<Container fullHeight>
					<Box className={containerClasses.container}>
						{(!currentEvent || showPreview) && (
							<div style={{ position: "relative" }}>
								<div style={{ position: "absolute", width: "100%" }}>
									<Loading isFetching />
								</div>
							</div>
						)}

						<Box
							className={classNames(commonClasses.headerContainer, classes.buttonBox)}
							display="flex"
							justifyContent="flex-end"
						>
							<TennisPrint
								fileName={`${fileName}.pdf`}
								showPreview={showPreview}
								setShowPreview={setShowPreview}
							/>
							<TennisExport fileName={`${fileName}.json`} boxscore={boxscore} />
						</Box>

						<Box className={classes.contentContainer}>
							{currentEvent && (singlesAvailable || doublesAvailable) && <GameStats />}
						</Box>
						{!singlesAvailable && !doublesAvailable && <MissingStatsContainer />}
					</Box>
				</Container>
			</Box>
		</>
	);
};

export default GameStatsContainer;
